import React, { useState } from 'react'
import { Menu, Select } from 'antd'
import { Button, Modal, useTraversal } from '@guillotinaweb/react-gmi'
import { CustomPreview } from '../../../components/preview'
import { BaseField, Field } from '../../../common/field'
import { ALL_COUNTRIES, COUNTRIES, LANGS, SHOPS, SITES } from '../../../consts'

function previewNL(id) {
  return (s) =>
    s.replace(
      /\/\w\w\/$$/g,
      (l) =>
        `/db/guillotina/newsletters/${id}/@previsualize?lang=${l.replace(
          /\//g,
          ''
        )}`
    )
}

export default function NLPreview({ id, ...props }) {
  const Ctx = useTraversal()
  const [email, setEmail] = useState('')
  const [country, setCountry] = useState('')
  const [shop, setShop] = useState('')
  const [status, setStatus] = useState({})
  const [lang, setLang] = useState('')
  const [domain, setDomain] = useState('')
  const [emailModal, setEmailModal] = useState(false)

  async function sendEmail(e) {
    e.preventDefault()
    setStatus({ type: 'loading' })

    if (!email || !country || !shop || !lang || !domain) {
      setStatus({
        type: 'error',
        message: 'Please, fill all fields in order to send the email',
      })
      return
    }

    const res = await Ctx.client.testEmailNL(id, {
      recipient: email,
      ctx: {
        country,
        shop,
        lang,
        domain,
      },
    })

    if (res.status >= 300) {
      setStatus({
        type: 'error',
        message: 'There is an error sending the email',
      })
      return
    }

    setEmailModal(false)
    setStatus({})
    Ctx.flash(`Email sent to ${email} successfully`, 'success')
  }

  return (
    <>
      <CustomPreview
        className="button is-light is-normal"
        preview={previewNL(id)}
        moreItems={
          <Menu.Item key="test-email">
            <div onClick={() => setEmailModal(true)}>Send a test email</div>
          </Menu.Item>
        }
        {...props}
      />
      <Modal isActive={emailModal} setActive={() => setEmailModal(false)}>
        <h2 style={{ marginBottom: 20 }}>Send a test email</h2>
        <form onSubmit={sendEmail}>
          <Field
            onChange={setEmail}
            label="Email"
            type="email"
            required
            value={email}
          />
          <BaseField label="Language">
            <Select
              allowClear
              required
              onChange={setLang}
              placeholder="Please select a language"
              style={{ width: '100%' }}
              value={lang}
            >
              {LANGS.map((lang) => (
                <Select.Option key={lang}>{lang.toUpperCase()}</Select.Option>
              ))}
            </Select>
          </BaseField>
          <BaseField label="Country">
            <Select
              allowClear
              required
              onChange={setCountry}
              placeholder="Please select a country"
              style={{ width: '100%' }}
              value={country}
            >
              {COUNTRIES.map((c) => (
                <Select.Option key={c}>{`${
                  ALL_COUNTRIES[c]
                } (${c.toUpperCase()})`}</Select.Option>
              ))}
            </Select>
          </BaseField>
          <BaseField label="Shop">
            <Select
              allowClear
              required
              onChange={setShop}
              placeholder="Please select a shop"
              style={{ width: '100%' }}
              value={shop}
            >
              {SHOPS.map((c) => (
                <Select.Option key={c}>{c.toUpperCase()}</Select.Option>
              ))}
            </Select>
          </BaseField>
          <BaseField label="Domain">
            <Select
              allowClear
              required
              onChange={setDomain}
              placeholder="Please select a domain"
              style={{ width: '100%' }}
              value={domain}
            >
              {SITES.map((c) => (
                <Select.Option key={c}>{c}</Select.Option>
              ))}
            </Select>
          </BaseField>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button disabled={status.type === 'loading'} type="submit">
              Send
            </Button>
          </div>
          {status.type === 'error' && (
            <div style={{ color: '#e91e63', textAlign: 'right' }}>
              {status.message}
            </div>
          )}
        </form>
      </Modal>
    </>
  )
}
